import BrandInfo from './BrandInfo';

export default BrandInfo;
